import React, { useEffect, useState } from 'react';
import * as S from './style';
import { getSubscription } from 'src/services/firebaseInit';
import { HostPlatform } from 'src/config/hostPlatform';
import { getAdminURL } from 'src/utils/organizationSettingsUrl';

function isTrial(): boolean {
  const subscription = getSubscription();
  return subscription && subscription.type === 'trial';
}

function AzureTrialBanner() {
  const [adminUrl, setAdminUrl] = useState('');

  useEffect(() => {
    if (!isTrial()) return;
    (async () => {
      setAdminUrl(await getAdminURL());
    })();
  }, []);

  if (!isTrial()) return <></>;

  const dateString = new Date(getSubscription().endsAt!).toLocaleDateString();
  return (
    <S.Container>
      <section>
        <S.InfoIcon />
      </section>
      <section>
        <h1>Trial reminder</h1>
        <p>
          Your trial ends on {dateString}. Purchase an annual subscription
          anytime on the{' '}
          <a target="_top" href={adminUrl}>
            Organization Settings page
          </a>
          . Questions? Contact us at{' '}
          <a rel="noreferrer" target="_top" href="mailto:support@appgami.com">
            support@appgami.com
          </a>
          .
        </p>
      </section>
    </S.Container>
  );
}

function EmptyTrialBanner() {
  return <></>;
}

const TrialBanner = HostPlatform.isAzure()
  ? AzureTrialBanner
  : EmptyTrialBanner;

export { TrialBanner };
